import { Directive, Host, ElementRef, Renderer2, Input, HostListener } from '@angular/core';
import { Platform } from 'ionic-angular';

/**
 * Generated class for the GdxTooltipDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[gdx-tooltip]', // Attribute selector
  host: { },
})
export class GdxTooltipDirective {
  @Input('tooltip-text') tooltipText: string;
  @Input('tooltip-position') tooltipPosition: string;
  @Input('tooltip-width') tooltipWidth: string = null;
  // @Input('tooltip-show-max') tooltiShowmax: string;

  element: any;
  mbTimeout: any;
  mbTimeout2: any;
  timeout: any;
  timeout2: any;
  offset: any = 8;
  isOpenMb: boolean = false;

  top: any;
  left:any;

  beforePosition:any;

  tabletSize: any = 768;

  constructor(
    @Host() public host: ElementRef, 
    public platform: Platform,
    public renderer: Renderer2) {
  }
  
  ngOnInit() {
  }

  @HostListener('mouseenter') onMouseEnter() {
    // Event hover masuk object 
    // console.log('mouseenter');
    // console.log(this.host);
    if (!this.platform.is('cordova') && !this.platform.is('android') && !this.platform.is('ios')){
      clearTimeout(this.timeout2);
      if (this.element) this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], this.element);
      this.element = null;
      if (!this.element) { this.showTooltip(); }
    }
    
  }

  @HostListener('mouseleave') onMouseLeave() {
    // Event hover keluar object 
    // console.log('mouseleave');
    if (!this.platform.is('cordova') && !this.platform.is('android') && !this.platform.is('ios')){
      clearTimeout(this.timeout);
      if (this.element) { this.hideTooltip(); }
    }
  }

  @HostListener('mousewheel') onMousewheel() {
    // console.log('mousewheel');
    // Event scroll untuk menghilangkan tooltip 
    if (this.element) this.renderer.removeClass(this.element, 'gdx-tooltip-show');
    if (this.element) this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], this.element);
    this.element = null;
    clearTimeout(this.timeout);
  }

  @HostListener('touchmove') onTouchMove(e:any) {
    // console.log('touchmove');
    // Event hold move object untuk mobile
    if(this.isOpenMb){
      if (this.element) this.renderer.removeClass(this.element, 'gdx-tooltip-show');
      if (this.element) this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], this.element);
      this.element = null;
      this.isOpenMb = false;
      clearTimeout(this.timeout);
    }
  }

  @HostListener('touchstart', ['$event']) onTouchStart(e:any) {
    // Event hold in object untuk mobile
    // console.log('touchstart');
    // if (this.platform.is('cordova') || this.platform.is('android') || this.platform.is('ios')){
    if (window.innerWidth < 768){
      this.mbTimeout = setTimeout(() => {
        clearTimeout(this.timeout);
        clearTimeout(this.timeout2);
        if (this.element) this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], this.element);
        this.element = null;
        if (!this.element) { this.showTooltip(); }
        this.isOpenMb = true;
        this.mbTimeout2 = setTimeout(() => {
          if(this.isOpenMb){
            this.hideTooltip();
            this.isOpenMb = false;
          }
        }, 3000);
      }, 300);
    }
  }

  @HostListener('touchend', ['$event']) onTouchEnd(e:any) {
    // console.log('touchend');
    // Event hold up object untuk mobile
    clearTimeout(this.mbTimeout);
    clearTimeout(this.mbTimeout2);
    if(this.isOpenMb){
      this.hideTooltip();
      this.isOpenMb = false;
    }
  }

  showTooltip(){
    // Event Memunculkan tooltip
    this.createElement();
    this.setPosition();
    this.setAnimation();
    this.renderer.addClass(this.element, 'gdx-tooltip-show');
  }

  hideTooltip() {
    // Event menyembunyikan tooltip

    if(this.tooltipPosition == "top"){
      this.element.style.top = (this.top+4)+"px";
    }else if(this.tooltipPosition == "bottom"){
      this.element.style.top = (this.top-4)+"px";
    }else if(this.tooltipPosition == "left"){
      this.element.style.left = (this.left+4)+"px";
    }else if(this.tooltipPosition == "right"){
      this.element.style.left = (this.left-4)+"px";
    }else{
      this.element.style.top = (this.top+4)+"px";
    }
    this.renderer.removeClass(this.element, 'gdx-tooltip-show');

    //Mengembalikan posisi ke semula setelah perubahan posisi karena responsive
    this.tooltipPosition = this.beforePosition;
    this.timeout2 = setTimeout(() => {
      if (this.element) this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], this.element);
      this.element = null;
    }, 500);
  }

  createElement(){
    // Membuat element tooltip
    this.element = this.renderer.createElement('div');
    this.renderer.addClass(this.element, 'gdx-tooltip');
    this.element.style.maxWidth = this.tooltipWidth;
    this.element.innerText = this.tooltipText;
    this.renderer.appendChild(document.getElementsByTagName("ion-app")[0], this.element);
  }

  setPosition(){
    // Mendapatkan posisi object X Y
    const hostPos = this.host.nativeElement.getBoundingClientRect();
    const tooltipPos = this.element.getBoundingClientRect();
    // console.log('host',hostPos);
    // console.log('top',hostPos.top);
    // console.log('right',(window.innerWidth - hostPos.right));
    // console.log('bottom',(window.innerHeight - hostPos.bottom));
    // console.log('left',hostPos.left);
    // console.log(this.element.offsetWidth);
    // console.log(this.element.offsetHeight);
    // console.log(this.tooltipPosition,' posisi');
    
    this.beforePosition = this.tooltipPosition;
    // Cek dan ubah posisi muncul tooltip sesuai offset layar agar responsive
    if(this.tooltipPosition == 'left' && hostPos.left < this.element.offsetWidth){
      this.tooltipPosition = 'right';
      this.beforePosition = 'left';
      // console.log('perubahan posisi');
    }else if(this.tooltipPosition == 'right' && (window.innerWidth - hostPos.right) < this.element.offsetWidth){
      this.tooltipPosition = 'left';
      this.beforePosition = 'right';
      // console.log('perubahan posisi');
    }else if(this.tooltipPosition == 'top' && hostPos.top < this.element.offsetHeight){
      this.tooltipPosition = 'bottom';
      this.beforePosition = 'top';
      // console.log('perubahan posisi');
    }else if(this.tooltipPosition == 'bottom' && (window.innerHeight - hostPos.bottom) < this.element.offsetHeight){
      this.tooltipPosition = 'top';
      this.beforePosition = 'bottom';
      // console.log('perubahan posisi');
    }

    // Membuat posisi tooltip sesuai set position
    if (this.tooltipPosition === 'top') {
      this.top = hostPos.top - tooltipPos.height - this.offset;
      this.left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }else if (this.tooltipPosition === 'bottom') {
      this.top = hostPos.bottom + this.offset;
      this.left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }else if (this.tooltipPosition === 'left') {
      this.top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      this.left = hostPos.left - tooltipPos.width - this.offset;
    }else if (this.tooltipPosition === 'right') {
      this.top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      this.left = hostPos.right + this.offset;
    }else{
      this.top = hostPos.top - tooltipPos.height - this.offset;
      this.left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }
    
    // Set style posisi top or left
    this.renderer.setStyle(this.element, 'top', this.top+"px");
    this.renderer.setStyle(this.element, 'left', this.left+"px");
  }

  setAnimation(){
    // Membuat animasi ketikas muncul tooltip
    if(this.tooltipPosition == "top"){
      this.renderer.addClass(this.element, 'tooltip-top');
    }else if(this.tooltipPosition == "bottom"){
      this.renderer.addClass(this.element, 'tooltip-bottom');
    }else if(this.tooltipPosition == "left"){
      this.renderer.addClass(this.element, 'tooltip-left');
    }else if(this.tooltipPosition == "right"){
      this.renderer.addClass(this.element, 'tooltip-right');
    }else{
      this.renderer.addClass(this.element, 'tooltip-top');
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/gdx-tooltip/gdx-tooltip.ts